<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/agentshare/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :show="true"
      @openAddDialog="openDialog"
      buttonName="购买金充值"
      addShowPower="/agentshare/add"
      :showDownloadPower="true"
      downloadPower="/agentshare/down"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      @down="down()"
    >
      <el-form-item label="代理商ID">
        <el-input v-model="formModel.userId" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input v-model="formModel.orderNo" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商姓名">
        <el-input v-model="formModel.userName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="代理商手机号">
        <el-input
          v-model="formModel.phoneNumber"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.operationType">
          <el-option
            v-for="item in operationType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="业务类型">
        <el-select v-model="formModel.operation">
          <el-option
            v-for="item in operation"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作类型">
        <el-select v-model="formModel.operationDirection">
          <el-option
            v-for="item in operationDirection"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账户类型">
        <el-select v-model="formModel.acctType">
          <el-option
            v-for="item in acctType"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="变动时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          :clearable="true"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="memId"
        label="代理商ID"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="代理商姓名"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="代理商手机号"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="sn"
        label="SN号"
        :formatter="formatterTableData"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="orderNo"
        label="订单号"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantName"
        label="商户名称"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="merchantNo"
        label="商户编码"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="业务类型"
        min-width="150"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="operationType"
        label="交易类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableoperationType"
      ></el-table-column>
      <el-table-column
        prop="operationDirection"
        label="操作类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableoperationDirection"
      ></el-table-column>
      <el-table-column
        prop="acctType"
        label="账户类型"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableacctType"
      ></el-table-column>
      <el-table-column
        prop="operationAmt"
        label="变动金额"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="balAmt"
        label="变动后金额"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="变动时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="260"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>变动金额：{{ dialogObj || 0 }}元</p>
      </div>
    </show-info-dialog>
    <form-dialog
      ref="formDialog"
      formDialogTitle="购买金账户充值"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
    >
      <el-form-item label-width="138px" label="源账户类型" prop="acctType">
        <el-select v-model="dialogModel.acctType">
          <el-option
            v-for="item in acctType.slice(2, acctType.length)"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="138px" label="源代理商ID" prop="fromUserId">
        <el-input-number
          :disabled="this.dialogModel.acctType == ''"
          v-model="dialogModel.fromUserId"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
          style="width: 227.5px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="138px" label="源姓名" prop="yuanName">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.yuanName"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="源手机号" prop="yuanPhone">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.yuanPhone"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="分润账户余额" prop="withdrawSum">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.withdrawSum"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="其他账户余额" prop="otherSum">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.otherSum"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="目的代理商ID" prop="toUserId">
        <el-input-number
          :disabled="this.dialogModel.acctType == ''"
          v-model="dialogModel.toUserId"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
          style="width: 227.5px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="138px" label="目的姓名" prop="muName">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.muName"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="目的手机号" prop="muPhone">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.muPhone"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="购买账户余额" prop="shoppingSum">
        <el-input
          disabled
          type="text"
          v-model="dialogModel.shoppingSum"
          style="width: 227.5px"
        ></el-input>
      </el-form-item>
      <el-form-item label-width="138px" label="充值金额" prop="number">
        <el-input-number
          v-model="dialogModel.number"
          :min="0"
          :max="999999999"
          :step="0.1"
          :precision="2"
          :controls="false"
          placeholder="请输入"
          style="width: 227.5px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label-width="138px" label="备注" prop="remark">
        <el-input
          v-model="dialogModel.remark"
          maxlength="200"
          show-word-limit
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "@/view/dialog/FormDialog";
import TransactionService from "service/TransactionService";
import FinanceService from "service/FinanceService";
import MallService from "service/MallService";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";
import LYFAcctTypes from "service/constant/LYFAcctTypes";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "agentshare",
  components: {
    CommonTopForm,
    CommonTable,
    ShowInfoDialog,
    FormDialog,
  },
  data() {
    return {
      dialogObj: "",
      formModel: {
        userId: "",
        orderNo: "",
        userName: "",
        phoneNumber: "",
        operationType: "",
        operation: "",
        operationDirection: "",
        acctType: "",
        time: "",
      },
      dialogModel: {
        fromUserId: undefined,
        yuanName: "",
        yuanPhone: "",
        withdrawSum: "",
        otherSum: "",
        toUserId: undefined,
        muName: "",
        muPhone: "",
        shoppingSum: "",
        number: undefined,
        acctType: "",
        remark: "",
      },
      dialogRules: {
        fromUserId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (!/^\d+$/.test(value)) {
                callback(new Error("请输入纯数字"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    const id = res.contents;
                    if (!id.id) {
                      callback(new Error("查询不到此用户"));
                      this.dialogModel.yuanName = "";
                      this.dialogModel.yuanPhone = "";
                      this.dialogModel.withdrawSum = "";
                      this.dialogModel.otherSum = "";
                    } else {
                      this.dialogModel.yuanName = id.realName;
                      this.dialogModel.yuanPhone = id.phoneNumber;
                      this.dialogModel.withdrawSum =
                        id.memAcct.withdrawSum / 100;
                      this.dialogModel.otherSum = id.memAcct.otherSum / 100;
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.dialogModel.yuanName = "";
                    this.dialogModel.yuanPhone = "";
                    this.dialogModel.withdrawSum = "";
                    this.dialogModel.otherSum = "";
                  }
                });
              }
            },
          },
        ],
        toUserId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (!/^\d+$/.test(value)) {
                callback(new Error("请输入纯数字"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    const id = res.contents;
                    if (!id.id) {
                      callback(new Error("查询不到此用户"));
                      this.dialogModel.muName = "";
                      this.dialogModel.muPhone = "";
                      this.dialogModel.shoppingSum = "";
                    } else {
                      this.dialogModel.muName = id.realName;
                      this.dialogModel.muPhone = id.phoneNumber;
                      this.dialogModel.shoppingSum =
                        id.memAcct.shoppingSum / 100;
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.dialogModel.muName = "";
                    this.dialogModel.yuanPhone = "";
                  }
                });
              }
            },
          },
        ],
        number: [
          {
            required: true,
            message: "请输入",
          },
        ],
        acctType: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      operationType: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      operation: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      operationDirection: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "1",
          dictValue: "加",
        },
        {
          dictKey: "2",
          dictValue: "减",
        },
      ],
      acctType: LYFAcctTypes,
      tableData: [],
      submitService: TransactionService.agentshareList,
      params: {},
      page: {},
      isPage: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.getTypeNames("交易类型", (res) => {
      this.operationType = [...this.operationType, ...res];
    });
    this.getTypeNames("业务类型", (res) => {
      this.operation = [...this.operation, ...res];
    });
    this.load();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        userId: this.formModel.userId,
        orderNo: this.formModel.orderNo,
        userName: this.formModel.userName,
        operationType: this.formModel.operationType,
        operation: this.formModel.operation,
        phoneNumber: this.formModel.phoneNumber,
        operationDirection: this.formModel.operationDirection,
        acctType: this.formModel.acctType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.formModel.time.length) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        fromUserId: this.dialogModel.fromUserId,
        toUserId: this.dialogModel.toUserId,
        number: this.dialogModel.number,
        acctType: this.dialogModel.acctType,
        remark: this.dialogModel.remark,
      };
      console.log(params);
      return params;
    },
    dialogService() {
      return TransactionService.agentshareAdd;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  methods: {
    load() {
      this.formModel = {
        operationType: "",
        operation: "",
        operationDirection: "",
        acctType: "",
        time: "",
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    openDialog(item) {
      this.$refs.formDialog.open();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.tatId,
        userId: val,
        acctType: this.dialogModel.acctType,
      };
      this.doLoad(
        FinanceService.getRealNameByPhone,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        fromUserId: undefined,
        yuanName: "",
        yuanPhone: "",
        withdrawSum: "",
        otherSum: "",
        toUserId: undefined,
        muName: "",
        muPhone: "",
        shoppingSum: "",
        number: undefined,
        acctType: "",
        remark: "",
      };
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    down() {
      this.doLoad(
        MallService.agentsharehj,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result / 100;
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    formatterTableoperationType(row, column, cellValue, index) {
      let value = "--";
      this.operationType.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    formatterTableoperationDirection(row, column, cellValue, index) {
      let value = "--";
      this.operationDirection.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/Transaction/AgentShare.vue